import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface NotificationClickEntityParams {
  type: string;
  notification_id?: number;
  was_read?: boolean;
}
export class NotificationClickEntity extends BaseEntityClass {
  notification_id?: number;
  was_read?: boolean;
  constructor(params: NotificationClickEntityParams) {
    super();
    this.type = params.type;
    this.entity_version = 2;
    this.notification_id = params.notification_id;
    this.was_read = params.was_read;
  }
}
